export default function toJS(identity) {
  return identity && identity.toJS ? identity.toJS() : identity
}
